import React, { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material/";
import { useTheme } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { helpers } from "../../../../common/lib";
import ImageControls from "../../../../common/components/ImageControls";
import actions from "../../../../Store/actions";
import styles from "./styles";
import { logToSentry } from "../../../../config/Sentry";
import CropIcon from "@mui/icons-material/Crop";

const ImageViewer = ({
    item,
    pageWidth,
    identifiers,
    assetAuditorImageId,
    altAssetImageId,
    assetAuditorId,
    altAssetId,
    assetAuditors,
    altAssets,
    auditControllers
}) => {
    const dispatch = useDispatch();
    const params = useParams();
    const theme = useTheme();

    const { auditId } = params;

    const handleImageCrop = async () => {
        const auditImage = { imageId: item.id, auditId: parseInt(auditId) };

        const res = await dispatch(
            actions.auditImages.create.postRequest(auditImage)
        );

        if (assetAuditorImageId) {
            const assetAuditor = helpers.getListItemForId(
                assetAuditors,
                assetAuditorImageId
            );
            const index = assetAuditor.auditImages.findIndex(
                (item) => item.id === res.auditImage.id
            );

            if (index === -1) {
                const controller = auditControllers.data.find(
                    (item) => item.auditAsset === assetAuditorId
                );
                if (controller) {
                    const imageIndex = controller.auditImages.findIndex(
                        (image) => image.id === res.auditImage.id
                    );
                    item.path = res.auditImage.path;

                    if (imageIndex !== -1) {
                        controller.auditImages[imageIndex] = res.auditImage;
                    }
                    await dispatch(
                        actions.auditControllers.create.merge(controller)
                    );
                }
            } else {
                assetAuditor.auditImages[index] = {
                    ...assetAuditor.auditImages[index],
                    ...res.auditImage
                };
                dispatch(actions.assetAuditors.create.merge([assetAuditor]));
            }
        } else if (altAssetImageId) {
            const altAsset = helpers.getListItemForId(
                altAssets,
                altAssetImageId
            );

            const index = altAsset.altAssetImages.findIndex(
                (item) => item.image.id === res.auditImage.id
            );

            altAsset.altAssetImages[index].image = {
                ...altAsset.altAssetImages[index].image,
                ...res.auditImage
            };
            dispatch(actions.altAssets.create.merge([altAsset]));
        }
    };

    const onRotation = async (angle) => {
        try {
            const { path, ...filteredData } = item;
            const res = await dispatch(
                actions.auditImages.create.patchRequest({
                    ...filteredData,
                    ...angle
                })
            );

            if (assetAuditorImageId) {
                const assetAuditor = helpers.getListItemForId(
                    assetAuditors,
                    assetAuditorImageId
                );
                const idx = assetAuditor.auditImages.findIndex(
                    (i) => i.id === res.auditImage.id
                );

                if (idx === -1) {
                    const controller = auditControllers.data.find(
                        (a) => a.auditAsset === assetAuditorId
                    );
                    controller.auditImages.forEach((i) => {
                        if (i.id === res.auditImage.id)
                            i.rotation = res.auditImage.rotation;
                    });
                    await dispatch(
                        actions.auditControllers.create.merge(auditControllers)
                    );
                } else {
                    assetAuditor.auditImages[idx] = {
                        ...assetAuditor.auditImages[idx],
                        ...res.auditImage
                    };
                    dispatch(
                        actions.assetAuditors.create.merge([assetAuditor])
                    );
                }
            } else if (altAssetImageId) {
                const altAsset = helpers.getListItemForId(
                    altAssets,
                    altAssetImageId
                );
                const idx = altAsset.altAssetImages.findIndex(
                    (i) => i.image.id === res.auditImage.id
                );
                altAsset.altAssetImages[idx].image = {
                    ...altAsset.altAssetImages[idx].image,
                    ...res.auditImage
                };
                dispatch(actions.altAssets.create.merge([altAsset]));
            }
        } catch (error) {
            logToSentry("On rotation:", { error });
            dispatch(actions.toast.create.error("Error rotating image"));
        }
    };

    return (
        <Box sx={styles(theme).imageViewController}>
            <ImageControls
                key={`image-controls-${item.id}`}
                imageUrl={item.path || ""}
                rotation={item.rotation}
                onRotationChange={onRotation}
            />
            {item.imageType <= 2 ? (
                <IconButton
                    onClick={handleImageCrop}
                    sx={{
                        position: "absolute",
                        top: 12,
                        right: 12,
                        zIndex: 10,
                        backgroundColor: "rgba(0,0,0,0.6)",
                        backdropFilter: "blur(4px)",
                        color: "#fff",
                        "&:hover": {
                            backgroundColor: "rgba(0,0,0,0.8)"
                        }
                    }}
                    aria-label="cropRotate"
                >
                    <CropIcon color="white" />
                </IconButton>
            ) : null}
            {identifiers[item.imageType] && (
                <Box sx={styles(theme).auditImageIdentifier}>
                    <Typography
                        align="center"
                        color="white"
                        variant="subtitle2"
                    >
                        {identifiers[item.imageType]}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default ImageViewer;
